module.exports = __webpack_public_path__ + "img/navodila_slika_2.c8f135a9.png";